import { useEffect, useState } from 'react';

import { NetworkStatus } from '#/service/constants';

const useOfflineNetwork = () => {
  const [isBannerHidden, setIsBannerHidden] = useState<boolean>(true);
  useEffect(() => {
    const hideNetworkState = () => setIsBannerHidden(false);
    const showNetworkState = () => setIsBannerHidden(true);
    // Previously we were using navigator.onLine to distinguish initial user connection.
    // However this caused inconsistent results as the value is not always correct.

    window.addEventListener(NetworkStatus.ONLINE, showNetworkState);
    window.addEventListener(NetworkStatus.OFFLINE, hideNetworkState);

    return () => {
      window.removeEventListener(NetworkStatus.ONLINE, showNetworkState);
      window.removeEventListener(NetworkStatus.OFFLINE, hideNetworkState);
    };
  }, []);

  return { isBannerHidden };
};

export default useOfflineNetwork;
